import { AdditionalRequestState, FetchedIdObject, IdObject } from "../dataTypes";

export const fileSliceName = "file";

export interface ResponseFile extends IdObject {
  name: string;
  description?: string;
  url: string;
  sequence: number;
  createdTimestamp?: number;
}
export interface UploadFile extends File {
  url: string;
}

export interface MylocFile extends ResponseFile, AdditionalRequestState, FetchedIdObject {}
